<template>
	<div class="container">
		<headMenu />
		<div class="row">
		<!-- <leftMenuPublic
			class="col-xl-3 col-lg-3 col-md-12 col-sm-12"
			select="1"
		/> -->
		<div
			id="one_time_password"
			class="col-xl-12 col-lg-12 col-md-12 col-sm-12 overflow-hidden p-3"
			:class=" (urlPath == '/proposal') ? '' : 'h-center' "
		>
			<div
				class=" col-sm-12 col-xs-12 p-3 border-15 shadow bg-white text-center float-right"
				:class=" (urlPath == '/proposal') ? 'col-lg-9 col-md-9 ' : 'col-lg-12 col-md-12 ' "
				style="
				display: flex;
				align-items: center;
				justify-content: center;
				align-content: center;
				"
			>
				<div style="width: 75%; max-width: 500px;">
				<div class="p-3 mb-3 text-center">
					<img :src="require('../../../assets/img/logo_c.svg')" width="189" />
				</div>
					<h2 class="text-center bMikhak">
						ورود به ایزی تیک
					</h2>
					<textInput
						type="number"
						@inputTxtFunc="(e)=>{ val.phone = e; }"
						@enter="( !validatePhone(val.phone) ) ? '' : sav() "
						:val="val.phone"
						label="شماره موبایل"
					/>

					<btn
						@clickMe="sav()"
						class="w-100 mt-3"
						textClass="w-100"
						text="ورود"
						:disable = " ( !validatePhone(val.phone) ) ? '1' : '0' "
						disableText = "شماره موبایل وارد شده اشتباه است"
					/>
					<!-- :disable = " ( !validatePhone(val.phone) ) ? '1' : '0' " -->
					<router-link to="/login">
						<btn
							class="w-100 mt-3"
							type="white"
							textClass="w-100 text-success"
							text="ورود با نام کاربری"
						/>
					</router-link>
					<br/>
					<div class="overflow-hidden">
						<div class="float-right" style="display: flex; align-items: center; height: 40;">
							قبلا ثبت نام نکرده اید؟
						</div>
						<router-link to="/getPhone">
							<btn type="outline-success" class="float-left" text="ثبت نام" />
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
		<footerPage
			style=" width: 100%;"
		/>
	</div>
</template>

<script>
	import textInput from  "../../../UI/input/textInput.vue";
	import footerPage from  "../../../UI/footer/footer.vue";
	import btn from  "../../../UI/button/btn.vue";
	import headMenu from  "../../../menu/headMenu.vue";
	import { validatePhone, indexFinder } from  "../../../assets/library/filter.js";
	import leftMenuPublic from  "../../../menu/leftMenuPublic.vue";
	import { error } from  "../../../assets/library/messege.js";

	export default {
			name: 'one_time_password',
		data(){
			return {
				error: error,
				validatePhone: validatePhone,
				indexFinder: indexFinder,
				imgurl: window.imgurl,
				baseurl: window.baseurl,
				flds: [],
				degrees: [],
				category: [],
				location: [],
				urlPath: null,
				val:{
					"phone": "",
				},
			}
		},
		components: {
			btn,
			textInput,
			headMenu,
			footerPage,
			leftMenuPublic,
		},
		props: [],
		mounted(){
			this.$localStorage.remove('user');
			this.$localStorage.remove('reload_admin');
			this.$swal.close();
			if(this.$localStorage.get('urlPath') != null){
				this.urlPath = this.$localStorage.get('urlPath');
				this.$localStorage.remove('urlPath');
			}
		},
		methods:{
			sav(THIS=this){
				if(this.val.phone==""){
					THIS.error(THIS, 'اطلاعات را تکمیل نمایید');
				} else if(!this.validatePhone(this.val.phone)){
					THIS.error(THIS, 'شماره موبایل اشتباه است');
				} else {
					window.$.post(THIS.baseurl + "user/check", { token: this.$localStorage.get("user"), phone: THIS.val.phone }, function(D){
						if(D.data != '0'){
							THIS.$localStorage.set('signup', THIS.val);
							THIS.$router.push('/oneTimePassword/check/phone');
						}else{
							THIS.val.phone = '';
							THIS.error(THIS, 'شماره تماس وارد شده قبلا در سیستم ثبت نام نکرده است')
						}
					}, "json");
				}
			},
			// *********************************************************************

			// *********************************************************************

			// *********************************************************************

			// *********************************************************************
			
			// *********************************************************************
		}
	}
</script>
<style>
	.minW{
		min-width: 98%;
	}
</style>
